module.exports = __webpack_public_path__ + "static/media/9.1f15762c.jpg";